import { type FormEvent, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SearchInput from '@/components/common/search-input';
import useAdjustLayout from '@/hooks/use-adjust-layout';
import cn from '@/utils/merge-class-names';

interface SearchBarProps {
  keyword?: string;
  onSearch: (keyword: string) => void;
  className?: string;
  onClear?: () => void;
}
export default function SearchBar({ keyword = '', className, onSearch, onClear }: SearchBarProps) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(keyword);
  const searchInput = useRef<HTMLInputElement>(null);

  const onSubmit = (el: FormEvent) => {
    el.preventDefault();

    const sanitizedKeyword = inputValue?.trim();
    if (sanitizedKeyword) onSearch(sanitizedKeyword);
    searchInput.current?.blur();
    (document.activeElement as HTMLElement).blur();
  };

  useAdjustLayout({ inputTargetSelector: 'input#search-input' });

  useEffect(() => {
    if (keyword) {
      setInputValue(keyword);
    }
  }, [keyword]);

  return (
    <div className={cn('flex relative w-full items-center gap-2', className)}>
      <form
        onSubmit={onSubmit}
        className='flex-1 flex items-center dropdown'>
        <SearchInput
          keyword={inputValue}
          setKeyword={setInputValue}
          clearKeyword={() => {
            setInputValue('');
            onSearch('');
            onClear?.();
          }}
          ref={searchInput}
          placeholder={t('search.search-contact-group-chat')}
          className='m-0 xs:mx-0 flex-1 mode-embedded:h-7 mode-embedded:text-body'
        />

        <button
          type='submit'
          className='btn btn-ghost btn-sm px-4 text-primary mode-embedded:layout-full:text-primary-content hover:bg-transparent'>
          {t('search.placeholder')}
        </button>
      </form>

      {/*<SearchHistory onSearch={onSearch} />*/}
    </div>
  );
}
